<template>
  <div class="segment-text">
    <div class="segment-text__title">
      {{ $t('shi-pin-jiao-ben') }}
    </div>
    <div class="segment-text__content" :class="{ 'segment-text__content-more': more }">
      <div class="segment-text__content-inner">
        <div v-for="(line, idx) in (text || '')?.split('\n')" :key="idx" class="segment-text__line">
          {{ line }}
        </div>
      </div>
      <div
        :class="['segment-text__more', { 'segment-text__more-active': more }]"
        @click="toggleMore"
      >
        {{ more ? $t('shou-qi') : $t('zhan-kai') }}
        <IconArrow class="segment-text__more-icon" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import IconArrow from '~/design/icons/dropdown.svg?component';
defineProps<{
  text: string;
}>();

const more = ref(false);

function toggleMore() {
  more.value = !more.value;
}
</script>

<style lang="scss" scoped>
.segment-text__title {
  line-height: var(--x-text-18-line-height);
  font-size: var(--x-text-18-size);
  font-weight: var(--x-weight-regular);
  color: var(--x-text-1);
  margin-bottom: 24px;
}

.segment-text__content {
  position: relative;
  border-radius: 12px;
  padding: 24px;
  overflow: hidden;
  max-height: 290px;
  min-height: 135px;
  color: var(--x-text-1);
  background-color: var(--x-back-3);
  font-size: 16px;
}

.segment-text__content-more {
  max-height: none;
}

.segment-text__line {
  margin: 0;
  line-height: 28px;
}

.segment-text__more {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: var(--x-back-3);
  color: var(--x-purple-6);
  font-size: 16px;
  line-height: 22px;
  font-weight: var(--x-weight-regular);

  &::before {
    position: absolute;
    transform: translateY(-100%);
    content: ' ';
    width: 100%;
    height: 52px;
    background: linear-gradient(
      180deg,
      rgba(240, 242, 245, 0) 0%,
      rgba(240, 242, 245, 0.9) 50%,
      #f0f2f5 100%
    );
  }

  .segment-text__more-icon {
    width: 18px;
    height: 18px;
    margin-left: 8px;
  }

  &.segment-text__more-active {
    background-color: transparent;
    position: relative;
    height: 46px;
    bottom: 0px;
    align-items: flex-end;

    &::before {
      opacity: 0;
    }

    .segment-text__more-icon {
      transform: rotate(180deg);
    }
  }
}
</style>
